
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSettingsIec as ObiSettingsIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-settings-iec.js';
 
 
 

 
 export const ObiSettingsIec = createComponent({
   react: React,
   tagName: 'obi-settings-iec',
   elementClass: ObiSettingsIecElement,
   events: {
     
   }
  });
 
 